<script setup>
  import { onMounted, ref, computed, onUnmounted } from "vue";
  import SwiperImages from "./SwiperImages.vue";

  const props = defineProps({
    modelData: Object,
    breadcrumb: Array
  });
  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const model = ref(props.modelData);
  const isFixed = ref(false);
  const buttonsRef = ref(null); // Ref específica para os botões
  const contentNewRef = ref(null);

  const galleryImages = computed(() => {
    if (!model.value.dynamicGalleries) {
      return [];
    }
    return model.value.dynamicGalleries.filter(item => item.type === "image");
  });

  const galleryVideos = computed(() => {
    if (!model.value.dynamicGalleries) {
      return [];
    }
    return model.value.dynamicGalleries.filter(item => item.type === "video");
  });

  const projects = ref([]);
  const nextProject = () => {
    if (projects.value.length === 0) {
      return;
    }
    const index = projects.value.findIndex(project => project.id === model.value.id);
    model.value = projects.value[index + 1] || projects.value[0];
    updateUrl(model.value.slug);
  };
  const prevProject = () => {
    if (projects.value.length === 0) {
      return;
    }
    const index = projects.value.findIndex(project => project.id === model.value.id);
    model.value = projects.value[index - 1] || projects.value[projects.value.length - 1];
    updateUrl(model.value.slug);
  };
  const updateUrl = (url) => {
    const pageUrl = new URL(window.location);
    const tempLink = new URL(url, window.location.origin);
    pageUrl.searchParams.forEach((value, key) => {
      tempLink.searchParams.append(key, value);
    });

    window.history.replaceState(null, "", tempLink.toString());
  };
  const fetchNextProject = async () => {
    try {
      const url = new URL(window.location.href);
      const lastSegment = url.pathname.split("/").filter(Boolean).pop();
      const requestData = {
        url: url.pathname.replace(lastSegment, "")
      };

      url.searchParams.forEach((value, key) => {
        requestData[key] = value;
      });

      const csrfToken = document.head.querySelector("meta[name=\"csrf-token\"]").content;
      const { data } = await axios.post(`/integrations/topcer_projects_next_prev_article`, requestData, {
        headers: {
          "X-CSRF-TOKEN": csrfToken
        }
      });
      projects.value = data || [];
      projects.value.forEach(project => {
        const pageUrl = new URL(window.location);
        const tempLink = new URL(project.slug, window.location.origin);
        const currentLastSegment = pageUrl.pathname.split("/").filter(Boolean).pop();
        const lastSegment = tempLink.pathname.split("/").filter(Boolean).pop();
        const newLink = new URL(`${pageUrl.pathname.replace(currentLastSegment, "")}${lastSegment}`, window.location.origin);
        project.slug = newLink.pathname;
      });
    } catch (error) {
    }
  };

  const handleScroll = () => {
    if (contentNewRef.value) {
      const rect = contentNewRef.value.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      isFixed.value = rect.bottom > windowHeight;
    }
  };

  const goBack = () => {
    if (props.breadcrumb.length > 1) {
      const prevItem = props.breadcrumb[props.breadcrumb.length - 2];
      window.location.href = prevItem.url;
    } else {
      window.history.back();
    }
  };



  onMounted(() => {
    fetchNextProject();
    window.addEventListener("scroll", handleScroll);
    handleScroll();
  });
  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
</script>
<template>
  <div class="pagina-project">
    <div class="blue-belt" id="projects-blue-belt">
      <h1>{{ model.title }}</h1>
    </div>
    <div class="container-page-project">
      <div class="container-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li
              v-for="(item, index) in breadcrumb"
              :key="item.id"
              class="breadcrumb-item"
              :class="{ active: index === breadcrumb.length - 1 }"
              :aria-current="index === breadcrumb.length - 1 ? 'page' : null">
              <a v-if="index < breadcrumb.length - 1" :href="item.url">{{ item.label }}</a>
              <span v-else>{{ item.label }}</span>
            </li>
          </ol>
        </nav>
      </div>
      <div class="button-content">
        <span @click="goBack" class="button-btn button-back">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20" fill="none">
           <g clip-path="url(#clip0_27_1361)">
           <path d="M9.88919 0.115234L0.230469 9.99828L9.88919 19.8813" stroke="#333" stroke-miterlimit="10" />
           </g>
           <defs>
           <clipPath id="clip0_27_1361">
           <rect width="10" height="20" fill="white" />
           </clipPath>
           </defs>
          </svg>
          {{ trans("Back") }}
        </span>
      </div>
      <div class="content-new" ref="contentNewRef">
        <h1>{{ model.title }}</h1>
        <div class="content">
          <div class="galeria">
            <swiper-images
              v-if="galleryImages.length > 0"
              :images="galleryImages" />
            <template v-for="(item, index) in galleryVideos" :key="index">
              <div class="video-container">
                <iframe
                  :src="item.url || item.fullUrl"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  width="100%"
                  height="315"
                ></iframe>
              </div>
            </template>
          </div>
          <div class="text-content">
            <div v-html="model.content"></div>
            <div class="docs-content" v-if="model.documents && model.documents.length > 0">
              <div v-for="document in model.documents" class="content-documents">
                <div v-if="document.files.length > 1" class="content-documents-files">
                  <h5>{{ document.name }}</h5>
                  <a target="_blank" v-for="file in document.files" :href="file.fullUrl">
                    {{ file.fullUrl }}</a>
                </div>
                <div v-else-if="document.files.length === 1" class="content-document-unite">
                  <a target="_blank" v-for="file in document.files" :href="file.fullUrl">
                    {{ document.name }}
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="content-buttons"
      :class="{ 'is-fixed': isFixed }"
      ref="buttonsRef">
          <span @click="prevProject" class="button-btn button-prev">
             {{ trans("Previous") }}
          </span>
      <span @click="nextProject" class="button-btn button-next">
            {{ trans("Next") }}
          </span>
    </div>
  </div>
</template>


<style scoped>
</style>
